import { render } from "./CourseList.vue?vue&type=template&id=a95fd7d6&scoped=true"
import script from "./CourseList.vue?vue&type=script&lang=js"
export * from "./CourseList.vue?vue&type=script&lang=js"

import "./CourseList.vue?vue&type=style&index=0&id=a95fd7d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a95fd7d6"]])

export default __exports__